const HeroVideo = (el) => {
    const playBtn = el.querySelector('.hero-video__toggle-play');
    const video = el.querySelector('.hero-video__video');
    const playLabel = playBtn.dataset.labelPlay || 'Play video';
    const pauseLabel = playBtn.dataset.labelPause || 'Pause video';

    if (!playBtn || !video) return;

    playBtn.addEventListener('click', togglePlayPause);

    video.addEventListener('ended', () => {
        setPlayingState(false);
    });

    function togglePlayPause() {
        if (video.paused) {
            video.play();
            setPlayingState(true);
        } else {
            video.pause();
            setPlayingState(false);
        }
    }

    function setPlayingState(playing) {
        playBtn.classList.toggle('is-playing', playing);
        playBtn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
    }

    video.play().then(() => setPlayingState(true)).catch(() => setPlayingState(false));
};

export default HeroVideo;
